import defaultsDeep from 'lodash/defaultsDeep';
import BaseConfig from './http.base-instance-config';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { getRegionVariable } from '@white-label-helper/get-region-variable';
import type { Options } from './axios-config';

const { interceptors } = BaseConfig;
const baseURL = `${getRegionVariable('domains.booking')}/v1`;

interface BookingInstance extends Options {
  baseURL: string | undefined;
}

const options: BookingInstance = defaultsDeep(
  {
    baseURL,
    headers: {
      Authorization: `Bearer ${getAppVariable('channel.token')}`,
    },
  },
  BaseConfig.options,
);

export default {
  interceptors,
  options,
};
